import { createSlice } from '@reduxjs/toolkit';
import { initAuthState, login, logout } from '../common/reducers/initContext';

export const authSlice = createSlice({
    name: 'auth',
    initialState: initAuthState,
    reducers: {
    },
    extraReducers: builder => {
        builder.addCase(logout, () => authSlice.getInitialState());
        builder.addCase(login, (state, action) => {
            state.token = action.payload.token;
            if (action.payload.refreshToken) {
                state.refreshToken = action.payload.refreshToken;
            }
        })
    }
});

export const signIn = (dispatch, token, refreshToken) => {
    dispatch(login({ token, refreshToken }));
}
export const isAuthenticated = state => state.auth.token != null;
export const getToken = state => state.auth.token;
export const getRefreshToken = state => state.auth.refreshToken;

const reducerDetails = { name: authSlice.name, reducer: authSlice.reducer };
export default reducerDetails;